import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { findAllImage, findGalleryCategories, findImage } from "../../api/apiService";

const FeaturedWork = () => {
    const [categories, setCategories] = useState([])
    const [imageUrl, setImageUrl] = useState([])
    const findData = async () => {
        try {
            const res = await findGalleryCategories();
            const renderAllImage = async (id) => {
                if (!id) return [];
                const idArray = Array.isArray(id) ? id : [id];
                const idsParam = idArray.join(",");
                const res = await findAllImage(idsParam);
                return res?.data?.[0]?.data || [];
            };
            // Wait for all images to resolve
            let imgArr = res?.data?.map(item => (item.categoryImage))
            setImageUrl((await renderAllImage(imgArr)));
            setCategories(res.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        findData()
    }, [])
    return (
        <section className="featured-work py-2 px-4 sm:px-6 lg:px-8 overflow-hidden">
            <div className="container mx-auto">
                <h2 className="text-2xl md:text-3xl pb-6 font-bold text-[#F37934] text-center mb-8">
                    FEATURED WORK
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 sm:gap-y-8 gap-x-4 max-w-5xl mx-auto font-quicksand">
                    {categories?.map((work, i) => (
                        <Link
                            key={i}
                            to={`/gallery?tab=${encodeURIComponent(work.categoryName)}`}
                            className="flex flex-col items-start px-2 "
                            data-aos="flip-left"
                            data-aos-delay={i * 50}
                            data-aos-duration="800" >
                            <img
                                src={imageUrl[i]}
                                alt={work.categoryName}
                                className="rounded-t-lg w-full max-w-md h-auto object-cover"
                            />
                            <p className="p-4  text-[#56453F] ">{work.categoryName}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FeaturedWork